export default __webpack_public_path__ + "static/media/(19).a942b9a4.JPG";